import React, { memo } from "react";
import ModuleTabContent from "components/layout-components/ModuleTabContent";
import Dashboard from "./Dashboard";
import Questions from "./Questions";
import AuditRegister from "./AuditRegister";
import AuditTracking from "./AuditTracking";
import Reports from "./Reports";

// All 5 screens from MajesticERP-LaundryAuditAdmin's own routes.js (Dashboard,
// Questions, Reports, Audit Register, Audit Tracking) — same pattern as the
// Cleaning Audit module (../cleaningAudit/), reused here: dedicated axios
// client, a two-step auth handoff cached in memory with auto-retry on 401,
// and screens rebuilt in antd rather than ported from the old React
// 15/Bootstrap 4-alpha client.
// Tabs (titles/order) are in NavigationConfig's "laundry-audit" entry.
const screens = {
  dashboard: <Dashboard />,
  questions: <Questions />,
  "audit-register": <AuditRegister />,
  "audit-tracking": <AuditTracking />,
  reports: <Reports />,
};

const LaundryAudit = () => <ModuleTabContent navKey="laundry-audit" screens={screens} />;

export default memo(LaundryAudit);
